export const UNKNOWN_USER_ID = -1;

export interface UserInfo {
    userId: number;
    userName: string;
    email: string;
    isAnonymous: boolean;
    firstName?: string;
    lastName?: string;
    lastLogin?: Date | string | null;
    phone?: string;
    zipCode?: string;
    country?: string;        // Country name (e.g., "United States")
    countryCode?: string;    // ISO country code (e.g., "US")
    address1?: string;
    address2?: string;
    cityName?: string;
    stateName?: string;
    userName_DisplayMenu?: string;  // For header/menu display
    userName_DisplayLogin?: string;  // For login forms

    // UserType fields from s_UserSelect
    userTypeId?: number;
    isAdmin?: boolean;
    isReseller?: boolean;
    isRestricted?: boolean;
    userTypeCode?: string;
    userTypeDescription?: string;

    // Password management
    mustChangePassword?: boolean;
}
